import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../utils/api';
import { S, REGIONS, CURRENCIES, NOTE_COLORS, Field, Select } from '../utils/styles';

export default function CustomerDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});
  const [yearFilter, setYearFilter] = useState('all');

  useEffect(() => { load(); }, [id]);

  const load = async () => {
    try {
      const { data: d } = await api.get(`/customers/${id}`);
      setData(d);
    setForm({ company_name:d.customer.company_name, country:d.customer.country, region:d.customer.region||'Other', contact_name:d.customer.contact_name||'', email:d.customer.email||'', phone:d.customer.phone||'', payment_terms:d.customer.payment_terms||'', shipping_terms:d.customer.shipping_terms||'', currency:d.customer.currency||'USD', permanent_notes:d.customer.permanent_notes||'', container_capacity:d.customer.container_capacity||null });
    } catch(e) { console.error('Error loading customer:', e); }
  };

  const save = async () => { await api.put(`/customers/${id}`, form); load(); setEditing(false); };
  const f = k => v => setForm(p => ({...p,[k]:v}));

  if (!data) return <div style={{ padding:40, textAlign:'center', color:'#9ca3af' }}>Loading...</div>;
  const { customer, orders, summary, notes } = data;
  const years = [...new Set(orders.map(o => o.order_date?.split('-')[0]))].sort().reverse();
  const filteredOrders = yearFilter === 'all' ? orders : orders.filter(o => o.order_date?.startsWith(yearFilter));

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:20 }}>
        <Link to="/customers" style={{ color:'#9ca3af', textDecoration:'none', fontSize:13 }}>← Customers</Link>
        <span style={{ color:'#d1d5db' }}>/</span>
        <span style={{ fontSize:18, fontWeight:600 }}>{customer.company_name}</span>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'280px 1fr', gap:20 }}>
        <div>
          <div style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:10, padding:16, marginBottom:12 }}>
            {!editing ? (
              <>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12 }}>
                  <div style={{ fontWeight:600, fontSize:15 }}>{customer.company_name}</div>
                  <button onClick={() => setEditing(true)} style={{ background:'none', border:'none', color:'#3b82f6', cursor:'pointer', fontSize:12 }}>Edit</button>
                </div>
                {[['Country',customer.country],['Region',customer.region],['Contact',customer.contact_name||'—'],['Email',customer.email||'—'],['Phone',customer.phone||'—'],['Currency',customer.currency],['Shipping',customer.shipping_terms||'—'],['Payment',customer.payment_terms||'—']].map(([k,v]) => (
                  <div key={k} style={{ display:'flex', justifyContent:'space-between', marginBottom:5, fontSize:13 }}>
                    <span style={{ color:'#6b7280' }}>{k}</span>
                    <span style={{ fontWeight:500, textAlign:'right', maxWidth:140, fontSize:12 }}>{v}</span>
                  </div>
                ))}
                {customer.permanent_notes && <div style={{ marginTop:10, fontSize:12, color:'#6b7280', fontStyle:'italic', background:'#f9fafb', padding:8, borderRadius:6, lineHeight:1.5 }}>{customer.permanent_notes}</div>}
              </>
            ) : (
              <>
                <div style={{ fontWeight:600, marginBottom:14 }}>Edit customer</div>
                {[['Company name','company_name'],['Country','country'],['Contact name','contact_name'],['Email','email'],['Phone','phone'],['Payment terms','payment_terms'],['Shipping terms','shipping_terms']].map(([label,key]) => (
                  <div key={key} style={{ marginBottom:10 }}><Field label={label} value={form[key]} onChange={f(key)} /></div>
                ))}
                <div style={{ marginBottom:10 }}><Select label="Region" value={form.region} onChange={f('region')} options={REGIONS} /></div>
                <div style={{ marginBottom:10 }}><Select label="Currency" value={form.currency} onChange={f('currency')} options={CURRENCIES} /></div>
                <div style={{ marginBottom:14 }}><label style={S.label}>Permanent notes</label><textarea value={form.permanent_notes} onChange={e => f('permanent_notes')(e.target.value)} style={{ ...S.input, height:72, resize:'vertical' }} /></div>
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={save} style={S.btnPrimary}>Save</button>
                  <button onClick={() => setEditing(false)} style={S.btnSecondary}>Cancel</button>
                </div>
              </>
            )}
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:12 }}>
            {[['Shipped',summary.shipped_count,`${customer.currency} ${(summary.shipped_value||0).toLocaleString(undefined,{maximumFractionDigits:0})}`,`${(summary.shipped_pcs||0).toLocaleString()} pcs`,'#10b981'],
              ['Active',summary.active_count,`${customer.currency} ${(summary.active_value||0).toLocaleString(undefined,{maximumFractionDigits:0})}`,`${(summary.active_pcs||0).toLocaleString()} pcs`,'#f59e0b'],
              ['All orders',summary.total_count,`${customer.currency} ${(summary.total_value||0).toLocaleString(undefined,{maximumFractionDigits:0})}`,`${(summary.total_pcs||0).toLocaleString()} pcs total`,'#3b82f6']
            ].map(([label,count,val,pcs,color]) => (
              <div key={label} style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:8, padding:12 }}>
                <div style={{ fontSize:11, color:'#9ca3af', marginBottom:2 }}>{label}</div>
                <div style={{ fontSize:18, fontWeight:700, color }}>{count}</div>
                <div style={{ fontSize:11, color:'#9ca3af' }}>{val}</div>
                <div style={{ fontSize:11, color:'#9ca3af' }}>{pcs}</div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:10, overflow:'hidden', marginBottom:16 }}>
            <div style={{ padding:'12px 16px', borderBottom:'1px solid #e5e7eb', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div style={{ fontWeight:600 }}>Order history</div>
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                <select value={yearFilter} onChange={e => setYearFilter(e.target.value)} style={{ padding:'5px 10px', border:'1px solid #e5e7eb', borderRadius:6, fontSize:12 }}>
                  <option value="all">All years</option>
                  {years.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
                <Link to="/orders/new" style={{ ...S.btnPrimary, textDecoration:'none', fontSize:12, padding:'5px 12px' }}>+ New order</Link>
              </div>
            </div>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr>{['PI Number','Date','Items','Pcs','Shipped','Value','Ship date','Status'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {filteredOrders.map(o => (
                  <tr key={o.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                    <td style={S.td}><Link to={`/orders/${o.id}`} style={{ color:'#3b82f6', fontWeight:600, textDecoration:'none', fontSize:13 }}>{o.pi_number}</Link></td>
                    <td style={{ ...S.td, color:'#6b7280', fontSize:12 }}>{o.order_date}</td>
                    <td style={S.td}>{o.item_count}</td>
                    <td style={S.td}>{(o.total_pcs||0).toLocaleString()}</td>
                    <td style={{ ...S.td, color: o.total_shipped_pcs >= o.total_pcs && o.total_pcs > 0 ? '#10b981':'#9ca3af' }}>{(o.total_shipped_pcs||0).toLocaleString()}</td>
                    <td style={{ ...S.td, fontWeight:500 }}>{customer.currency} {(o.order_value||0).toLocaleString(undefined,{maximumFractionDigits:0})}</td>
                    <td style={{ ...S.td, color:'#6b7280', fontSize:12 }}>{o.expected_ship_date||'—'}</td>
                    <td style={S.td}><span style={{ background:o.status==='closed'?'#f0fdf4':'#eff6ff', color:o.status==='closed'?'#10b981':'#3b82f6', padding:'2px 8px', borderRadius:20, fontSize:11 }}>{o.status}</span></td>
                  </tr>
                ))}
                {filteredOrders.length === 0 && <tr><td colSpan={8} style={{ textAlign:'center', padding:20, color:'#9ca3af' }}>No orders</td></tr>}
              </tbody>
            </table>
          </div>

          <div style={{ background:'#fff', border:'1px solid #e5e7eb', borderRadius:10, padding:16, marginTop:16 }}>
              <div style={{ fontWeight:600, marginBottom:12 }}>Notes from past orders</div>
              {notes.length === 0 && <div style={{ color:'#9ca3af', fontSize:13 }}>No notes yet. Notes added on orders will appear here.</div>}
              {notes.slice(0,5).map(n => {
                const nc = NOTE_COLORS[n.category] || NOTE_COLORS.General;
                return (
                  <div key={n.id} style={{ borderBottom:'1px solid #f3f4f6', paddingBottom:10, marginBottom:10 }}>
                    <div style={{ display:'flex', gap:8, marginBottom:4 }}>
                      <span style={{ fontSize:11, background:nc.bg, color:nc.color, padding:'2px 8px', borderRadius:20 }}>{n.category}</span>
                      <span style={{ fontSize:11, color:'#9ca3af' }}>{n.pi_number} · {n.created_at?.split('T')[0]}</span>
                    </div>
                    <div style={{ fontSize:13, color:'#374151' }}>{n.note}</div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
